module.exports = __webpack_public_path__ + "img/screen6.98431086.png";